// A likely misspelled email (feedback 14-oct: orders came in as "@gmmail.com",
// "@gamil.com", and the client never got our emails): the address as it was
// probably meant, or null. Only the domain is checked: one of the common
// providers off by a letter or two (or two swapped), or ".con" for ".com".
// Real domains that look like them (mail.com, ymail.com...) are left alone.
const PROVIDERS = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com", "icloud.com", "aol.com", "live.com", "msn.com", "comcast.net", "protonmail.com"];
const KNOWN = new Set([
  ...PROVIDERS, "googlemail.com", "ymail.com", "rocketmail.com", "mail.com", "email.com", "gmx.com", "gmx.net", "me.com", "mac.com",
  "proton.me", "hotmail.es", "hotmail.co.uk", "hotmail.fr", "hotmail.it", "outlook.es", "live.co.uk", "live.com.mx", "yahoo.es",
  "yahoo.com.mx", "yahoo.co.uk", "yahoo.com.ar", "yahoo.com.br", "att.net", "verizon.net", "sbcglobal.net", "cox.net", "aim.com",
  "zoho.com", "yandex.com", "qq.com", "163.com", "uol.com.br", "bol.com.br", "terra.com.br", "yopmail.com", "mailinator.com",
]);
const TLD_TYPOS = { con: "com", cpm: "com", cmo: "com", ocm: "com", comm: "com", vom: "com", xom: "com", cim: "com", ner: "net", nte: "net" };

// Edits between two words, a swap of two neighbours counting as one.
const distance = (a, b) => {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j += 1) d[0][j] = j;
  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
  }
  return d[a.length][b.length];
};

export const emailTypoFix = (email) => {
  const value = String(email || "").trim().toLowerCase();
  const at = value.lastIndexOf("@");
  if (at < 1 || at === value.length - 1) return null;
  const local = value.slice(0, at);
  let domain = value.slice(at + 1);
  if (KNOWN.has(domain)) return null;
  const dot = domain.lastIndexOf(".");
  const tld = dot > 0 ? domain.slice(dot + 1) : "";
  let fixed = false;
  if (TLD_TYPOS[tld]) {
    domain = `${domain.slice(0, dot)}.${TLD_TYPOS[tld]}`;
    fixed = true;
    if (KNOWN.has(domain)) return `${local}@${domain}`;
  }
  const near = PROVIDERS.map((p) => [p, distance(domain, p)])
    .filter(([p, n]) => n > 0 && n <= (p.length > 9 ? 2 : 1))
    .sort((x, y) => x[1] - y[1])[0];
  if (near) return `${local}@${near[0]}`;
  return fixed ? `${local}@${domain}` : null;
};
